import { AfterViewInit, ChangeDetectionStrategy, Component } from '@angular/core';
import { EnvironmentService } from '../../services/environment/environment.service';
import { googleAnalytics } from '../../../../assets/google-analytics/ga';

@Component({
  selector: 'gtd-analytics',
  template: '',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [EnvironmentService],
})
export class AnalyticsComponent implements AfterViewInit {
  constructor(private envService: EnvironmentService) {}

  public ngAfterViewInit() {
    const vars = this.envService.getVars();
    if (vars.googleAnalyticsId) {
      googleAnalytics(vars.googleAnalyticsId);
    }
  }
}
